// extracted by mini-css-extract-plugin
export default {"container":"ImageSlider_container__tRM6U","nav":"ImageSlider_nav__HUXJ8","nav__btn":"ImageSlider_nav__btn__r7nS2","nav__btn__hide":"ImageSlider_nav__btn__hide__kMO5d"};